<template>
  <div class="select-holiday">
    <v-select
      class="select-box"
      :value="selectedHoliday"
      @input="handleClick"
      :options="holidayOptions"
      placeholder="選択"
      :clearable="false"
      :filterable="false"
    >
      <template v-slot:no-options>-</template>
    </v-select>
  </div>
</template>

<script>
import vSelect from "vue-select";
import moment from "moment-timezone";
import { DeviceInfoMixin, ColorMixin } from "@/mixins";
import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const enterpriseCrewDayOffDayApi = AiseaApiFactory.get(
  "enterpriseCrewDayOffDay",
);

const HOLIDAY_OPTIONS = [
  {
    id: 0,
    label: "未設定",
  },
  {
    id: 1,
    label: "休日（全休）",
  },
  {
    id: 2,
    label: "休日（半休）",
  },
  {
    id: 3,
    label: "補償休日（陸上）",
  },
  {
    id: 4,
    label: "補償休日（船上）",
  },
  {
    id: 5,
    label: "有給休暇（全休）",
  },
  {
    id: 6,
    label: "有給休暇（半休）",
  },
];

export default {
  name: "SelectHolidayCell",
  mixins: [DeviceInfoMixin, ColorMixin],
  components: {
    vSelect,
  },
  props: {
    enterpriseCrewId: { type: String, require: true },
    holidayOrCompensationHoliday: { type: Number },
    holidayOptions: { type: Array, default: () => HOLIDAY_OPTIONS },
    dayOff: { type: Number, default: 0 },
    dayOffId: { type: String, default: null },
    date: { Type: String, default: null },
    searchEnterpriseCrewDayOffDay: { Type: Function, default: () => {} },
    fetchHolidaySummary: { Type: Function, default: () => {} },
  },
  data() {
    return {
      selectedHoliday: this.holidayOptions[0],
    };
  },
  watch: {
    dayOff() {
      this.selectedHoliday =
        this.holidayOptions.find(({ id }) => id === this.dayOff) ||
        this.holidayOptions[0];
    },
  },
  computed: {
    dateForRequest() {
      return moment(this.date, "YYYYMMDD").format("YYYY-MM-DD");
    },
  },
  methods: {
    async handleClick(nextSelectedHoliday) {
      const curSelectedHoliday = this.selectedHoliday;
      const updateDayOff = this.updateDayOffFactory(this.dayOff);
      this.selectedHoliday = nextSelectedHoliday;
      try {
        this.$vs.loading({ color: this.AISEA_COLOR.BLUE, });

        const res = await updateDayOff(this.selectedHoliday.id);
        if (res.status !== true) throw new Error();

        this.$vs.notify({
          title: "休日情報を更新しました",
          color: "success",
          iconPack: "feather",
          icon: "icon-x-square",
        });
      } catch (err) {
        // 失敗なら、休日を戻す
        this.selectedHoliday = curSelectedHoliday;
        this.$vs.notify({
          title: "休日情報の更新に失敗しました",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square",
        });
      } finally {
        this.$vs.loading.close();
        this.searchEnterpriseCrewDayOffDay();
        this.fetchHolidaySummary();
      }
    },
    updateDayOffFactory(curDayOff) {
      return async (nextDayOff) => {
        // 使用するAPIを変えたものを出す
        // 未設定 -> 未設定以外
        if (!curDayOff || curDayOff === HOLIDAY_OPTIONS[0].id)
          return this.createEnterpriseCrewDayOffDay(
            this.enterpriseCrewId,
            this.dateForRequest,
            Number(nextDayOff),
          );
        // 未設定以外 -> 未設定
        if (nextDayOff === HOLIDAY_OPTIONS[0].id)
          return this.deleteEnterpriseCrewDayOffDay(
            this.enterpriseCrewId,
            this.dayOffId,
          );
        // 上記以外
        return this.updateEnterpriseCrewDayOffDay(
          this.enterpriseCrewId,
          this.dayOffId,
          this.dateForRequest,
          Number(nextDayOff),
        );
      };
    },
    async createEnterpriseCrewDayOffDay(enterpriseCrewId, date, type) {
      return enterpriseCrewDayOffDayApi.create(enterpriseCrewId, date, type);
    },
    async updateEnterpriseCrewDayOffDay(
      enterpriseCrewId,
      enterpriseCrewDayOffDayId,
      date,
      type,
    ) {
      return enterpriseCrewDayOffDayApi.update(
        enterpriseCrewId,
        enterpriseCrewDayOffDayId,
        date,
        type,
      );
    },
    async deleteEnterpriseCrewDayOffDay(
      enterpriseCrewId,
      enterpriseCrewDayOffDayId,
    ) {
      return enterpriseCrewDayOffDayApi.delete(
        enterpriseCrewId,
        enterpriseCrewDayOffDayId,
      );
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.selectedHoliday = this.holidayOptions.find(
      ({ id }) => id === this.dayOff,
    );
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
.select-holiday {
  display: flex;
  flex-grow: 1;
  .select-box {
    width: 100%;
    height: 30px;
  }
  .vs__dropdown-toggle {
    height: 100% !important;
    background: white;
    .vs__search {
      height: 0;
    }
  }
  .vs__dropdown-option {
    padding: 5px 10px 5px 14px;
  }
  .vs__dropdown-menu {
    min-width: 100%;
    width: fit-content;
  }
  .vs__selected-options {
    align-items: center;
    width: 85%;
  }
  .vs__selected {
    margin-top: 0px;
    width: 100%;
  }
  .holiday-option-selected {
    display: flex;
    align-items: center;
    text-overflow: ellipsis;
    width: 100%;
  }
  .selected-description {
    flex-grow: 1;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
}
</style>
